import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AddLinkIcon from '@mui/icons-material/AddLink';
import { func, number, oneOfType, shape, string } from 'prop-types';
import * as R from 'ramda';

const SearchResult = ({
  destination,
  idName,
  info,
  setDestinationName,
  setDestinationState,
  setExpanded,
  setInfo,
}) => {
  const { controlNumbers = [] } = info;
  const {
    destinationAddress,
    destinationCity,
    destinationIdName,
    destinationName,
    destinationState,
  } = destination;

  const handleClick = R.compose(
    () => setExpanded(false),
    () => setDestinationState({ id: '', name: '' }),
    () => setDestinationName(''),
    setInfo,
    R.curryN(2, R.assoc('controlNumbers')),
    R.update(R.findIndex(R.propEq('idName', idName), controlNumbers), R.__, controlNumbers),
    R.mergeRight(R.find(R.propEq('idName', idName), controlNumbers))
  );

  return (
    <Box sx={{ columnGap: 1, display: 'grid', gridTemplateColumns: '1fr 2fr 48px' }}>
      <Typography variant="body2">{destinationIdName}</Typography>

      <Stack spacing={0.5} sx={{ gridColumn: '2 / 3' }}>
        <Typography variant="body2">{destinationName}</Typography>
        {destinationAddress && <Typography variant="body2">{destinationAddress}</Typography>}
        <Typography variant="body2">
          {destinationCity}, {destinationState}
        </Typography>
      </Stack>

      <Button
        data-testid="add"
        onClick={() => handleClick(destination)}
        sx={{
          '@media (hover:none)': {
            '&:hover': {
              backgroundColor: 'transparent',
              boxShadow: 'none',
            },
          },
          height: 32,
          minWidth: 48,
          mt: -1,
          pt: 0,
        }}
        variant="text"
      >
        <AddLinkIcon />
      </Button>
    </Box>
  );
};

SearchResult.propTypes = {
  destination: shape({}).isRequired,
  idName: oneOfType([number, string]).isRequired,
  info: shape({}).isRequired,
  setDestinationName: func.isRequired,
  setDestinationState: func.isRequired,
  setExpanded: func.isRequired,
  setInfo: func.isRequired,
};

export default SearchResult;
